"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-fermo-della-battaglia": {
    "9aa50986": [{
      "hkey": "ab162f22",
      "slug": "san-fermo-della-battaglia",
      "name": "San Fermo della Battaglia",
      "primary": true,
      "skipSearch": false
    }],
    "dasia-ca-martello": [{
      "hkey": "ab162f22",
      "slug": "san-fermo-della-battaglia",
      "name": "San Fermo della Battaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c13a6f62": [{
      "hkey": "ab162f22",
      "slug": "san-fermo-della-battaglia",
      "name": "San Fermo della Battaglia",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "ab162f22",
      "slug": "san-fermo-della-battaglia",
      "name": "San Fermo della Battaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;